import { SEARCH_API_ROOT } from '../../config';

export const SEARCH_VERSION = 'v3.0';
export const SEARCH_URL = `${SEARCH_API_ROOT}/api/${SEARCH_VERSION}/salons.json`;
export const DEFAULT_SEARCH_SIZE = 20;
